import IconButton from "@pathwright/ui/src/components/button/IconButton"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import Text from "@pathwright/ui/src/components/ui/Text"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

const LoadingWrap = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: center;
  align-items: center;
  min-height: 300px;
`

export const DefaultLoadingWithTimeout = () => (
  <div style={{ minHeight: 300 }}>
    <LoadingWithTimeout timeoutValue={30 * 1000} onRefresh={null} />
  </div>
)

const LoadingWithTimeout = (props) => {
  const {
    timeoutValue = 5000,
    onRefresh,
    message = "Oops, something went wrong, please try refreshing."
  } = props

  const mountedRef = React.useRef(false)

  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      if (!mountedRef.current) return
      setLoading(false)
    }, timeoutValue)

    mountedRef.current = true

    return () => {
      clearTimeout(timeout)
      mountedRef.current = false
    }
  }, [])

  const handleClickRefresh = (e) => {
    if (onRefresh) return onRefresh(e)

    // Refresh page manually if no func provided
    window.location.reload()
  }

  if (loading) {
    return <LoadingCircle />
  }

  return (
    <LoadingWrap>
      <Text.Body>{message}</Text.Body>
      <IconButton
        styleType="tertiary"
        icon="skip-forward-2"
        onClick={handleClickRefresh}
      />
    </LoadingWrap>
  )
}

LoadingWithTimeout.propTypes = {
  timeoutValue: PropTypes.number.isRequired,
  message: PropTypes.string,
  onRefresh: PropTypes.func
}

export default LoadingWithTimeout
